module.exports = __webpack_public_path__ + "img/弹幕设置.1d1500e7.png";